import { baseErrorHandler } from '@queries/baseErrorHandler';
import { $api } from '@service/RequestService';
import { useQuery } from 'react-query';

import { queryKeys } from '../constants';
import { WidgetModel } from '../models';

export function useGetWidgets(dashboardId: number) {
  return useQuery<WidgetModel[]>({
    queryFn: async () => {
      const res = await $api.get(`/v1/dashboard/widget/${dashboardId}`);

      return res?.data?.data;
    },
    queryKey: [queryKeys.WIDGETS, dashboardId],
    onError: baseErrorHandler,
    retry: false,
    refetchOnWindowFocus: false,
    enabled: !!dashboardId
  });
}
